// Drag and drop types of the Tasks page. They are kept apart from the library
// ones ('folder', 'form', 'file') so a task is never dropped into a corporate
// library folder, and the other way round.
export const DND_TYPE_TASK = 'task';
export const DND_TYPE_TASK_FOLDER = 'task-folder';
export const DND_TYPE_TASK_FORM = 'task-form';

/**
 * The folder a drop lands in.
 *
 * A drop target is either a folder of the current level or a breadcrumb: the
 * root breadcrumb has no id, which is exactly the "outside every folder" level.
 */
export const getDropTargetFolderId = (dropTarget) => dropTarget?.id ?? null;

// Mirrors the ``max_length`` of ``Task.name`` in the backend: the input is capped
// at it so a name that the API would reject with a 400 cannot be typed at all.
export const TASK_NAME_MAX_LENGTH = 150;
